export default {
	menu: [],
	user: {},
	totalLogs: 0,
	Logs: []
}
